module.exports = __webpack_public_path__ + "static/media/r.201b9079.jpg";